var e = /* @__PURE__ */ ((n) => (n.Polygon = "Polygon", n.PolygonTestnet = "Mumbai", n.Ronin = "Ronin", n.RoninTestnet = "Saigon", n))(e || {}), t = /* @__PURE__ */ ((n) => (n.None = "None", n.Polygon = "Polygon", n.Ronin = "Ronin", n))(t || {}), o = /* @__PURE__ */ ((n) => (n.Mainnet = "mainnet", n.Testnet = "testnet", n))(o || {}), a = /* @__PURE__ */ ((n) => (n.POLYGON = "POLYGON", n.RONIN = "RONIN", n))(a || {});
const c = 500, r = {
  mainnet: [
    {
      chainId: 2020,
      chainHexId: "0x7E4",
      chainAddressType: "RONIN",
      chainName: "Ronin - Mainnet",
      rpcUrl: "",
      walletConnectSupported: !1
    },
    {
      chainId: 137,
      chainHexId: "0x89",
      chainName: "Polygon - Mainnet",
      chainAddressType: "POLYGON",
      rpcUrl: "https://polygon-rpc.com/",
      walletConnectSupported: !0
    }
  ],
  testnet: [
    {
      chainId: 2021,
      chainHexId: "0x7E5",
      chainName: "Ronin - Testnet",
      chainAddressType: "RONIN",
      rpcUrl: "",
      walletConnectSupported: !1
    },
    /**
     * @see https://support.polygon.technology/support/solutions/articles/82000907114-how-to-add-amoy-network-in-your-wallet-
     */
    {
      chainId: 80002,
      chainHexId: "0x13882",
      chainName: "Polygon - Testnet",
      chainAddressType: "POLYGON",
      rpcUrl: "https://rpc-amoy.polygon.technology/",
      walletConnectSupported: !0
    }
  ]
};
export {
  r as CHAIN_CONFIG_MAP,
  a as ChainAddressType,
  o as ChainEnvironment,
  t as ChainNetworkType,
  e as ChainType,
  c as TRANSACTION_BLOCK_TIMEOUT
};
//# sourceMappingURL=chain.js.map
